import { gsap } from "@/shared/lib/gsap";
import { RefObject, useCallback } from "react";

interface UseHeroAnimationProps {
  textBoxRef: RefObject<HTMLDivElement | null>;
  modelImgBoxRef: RefObject<HTMLDivElement | null>;
  onComplete?: () => void;
}

export function useHeroAnimation({ textBoxRef, modelImgBoxRef, onComplete }: UseHeroAnimationProps) {
  const startHeroAnimation = useCallback(() => {
    const textBox = textBoxRef.current;
    const modelImgBox = modelImgBoxRef.current;

    if (!textBox || !modelImgBox) return;

    // 기존 애니메이션 중지 및 초기 상태 설정
    gsap.killTweensOf([textBox, modelImgBox]);
    gsap.set(textBox, { opacity: 0, y: -100 });
    gsap.set(modelImgBox, { opacity: 0, y: 50 });

    // 애니메이션 타임라인
    const animation = gsap.timeline({
      onComplete: () => {
        onComplete?.();
      },
    });

    // 텍스트박스는 위에서 원래 위치로 내려옴
    animation.fromTo(textBox, { opacity: 0, y: -100 }, { opacity: 1, y: 0, duration: 1, ease: "power2.out" });

    // 이미지는 아래에서 원래 위치로 올라옴
    animation.fromTo(
      modelImgBox,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.2, ease: "power2.out" },
      "-=0.3",
    );
  }, [textBoxRef, modelImgBoxRef, onComplete]);

  return { startHeroAnimation };
}
